import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { type FeedFlowItem } from '@src/services/interface';
import Notice from '@src/mobile/components/notice';
import Reveal from '@src/mobile/components/reveal';
import PreText from '@src/mobile/article/layout/content/components/preText';
import Line from '@src/mobile/article/layout/content/components/line';
import NoticeResult from '@src/mobile/article/layout/content/components/noticeResult';
import PicTextVideo from '@src/mobile/article/layout/content/components/picTextVideo';
import Vote from '@src/mobile/components/vote';
import Tweet from '@src/mobile/components/tweet';
import VotePerson from '@src/mobile/article/layout/content/components/votePerson';
import { getQuery } from '@src/utils';

type PredictContentProps = {
    content: FeedFlowItem | null;
};

const PredictContent = ({ content }: PredictContentProps) => {
    const summary = content?.summary;
    const unlockTime = content?.unlockTime;
    const isReveal = content?.unlock;
    const voteRevealOption = content?.post?.vote?.option || [];
    const userId = getQuery(window.location.href, 'userId') || '';
    let voteRevealNum = 0;

    voteRevealOption.forEach((item) => {
        if (item?.num && item?.title === '预言的很准') {
            voteRevealNum = item?.num;
        }
    });
    const summaryData = {
        hasContent: !!summary,
        text: summary || '',
    };
    const noticeData = {
        unlockTime,
        isFeed: false,
    };
    const revealData = {
        peopleNum: voteRevealNum,
        isFeed: false,
    };
    const picTextVideo = {
        richContent: content?.richContent,
        richResource: content?.richResource,
    };
    const voteData = {
        isFeed: false,
        hasVote: content?.post?.hasVote || false,
        vote: content?.post?.vote || {},
        type: content?.type || '',
        callAppData: {
            docType: 'flutter',
            pid: `/detail?id=${content?.id}&ref=outside`,
            kind: 'inter_txs04',
            noKindFrom: 1,
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1388162036581',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8990',
        },
        statisticsData: isReveal
            ? {
                  behavior: 'action',
                  type: 'sharepage_app_start',
                  button_name: 'e',
                  user_id: userId,
              }
            : {
                  behavior: 'action',
                  type: 'sharepage_app_start',
                  button_name: 'c',
                  user_id: userId,
              },
    };
    const tweetData = {
        isFeed: false,
        forwardStatus: content?.forwardStatus,
        forwardItem: content?.forwardItem?.forwardList?.[0],
        post: content?.post,
    };
    const votePersonData = {
        vote: content?.post?.vote || '',
        userId,
    };
    const noticeResultData = {
        time: unlockTime,
        callAppData: {
            docType: 'flutter',
            pid: `/detail?id=${content?.id}&ref=outside`,
            kind: 'inter_txs03',
            noKindFrom: 1,
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1387812109167',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8989',
        },
    };

    return (
        <>
            {isReveal ? <Reveal content={revealData} /> : <Notice content={noticeData} />}
            <PreText content={summaryData} />
            {isReveal ? (
                <>
                    <Line />
                    <PicTextVideo content={picTextVideo} />
                </>
            ) : null}
            {isReveal ? <Vote content={voteData} /> : null}
            {isReveal ? null : <NoticeResult content={noticeResultData} />}
            <Tweet content={tweetData} />
            <VotePerson content={votePersonData} />
        </>
    );
};

export default errorBoundary(PredictContent);
